/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-stock.reducer';

export const PharmacyStockDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyStockEntity = useAppSelector(state => state.pharmacyStock.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyStockDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyStock.detail.title">PharmacyStock</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.id}</dd>
          <dt>
            <span id="brandId">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.brandId">Brand Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.brandId}</dd>
          <dt>
            <span id="stockQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.stockQty">Stock Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.stockQty}</dd>
          <dt>
            <span id="manufacDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.manufacDate">Manufac Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.manufacDate}</dd>
          <dt>
            <span id="expDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.expDate">Exp Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.expDate}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.cursor}</dd>
          <dt>
            <span id="batchNumber">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.batchNumber">Batch Number</Translate>
            </span>
            <UncontrolledTooltip target="batchNumber">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.help.batchNumber" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyStockEntity.batchNumber}</dd>
          <dt>
            <span id="taxCode">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.taxCode">Tax Code</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.taxCode}</dd>
          <dt>
            <span id="mrp">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.mrp">Mrp</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.mrp}</dd>
          <dt>
            <span id="price">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.price">Price</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.price}</dd>
          <dt>
            <span id="remainingQuantity">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.remainingQuantity">Remaining Quantity</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.remainingQuantity}</dd>
          <dt>
            <span id="packs">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.packs">Packs</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.packs}</dd>
          <dt>
            <span id="HSNCode">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.HSNCode">HSN Code</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.HSNCode}</dd>
          <dt>
            <span id="rack">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.rack">Rack</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.rack}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.discount}</dd>
          <dt>
            <span id="available">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.available">Available</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.available ? 'true' : 'false'}</dd>
          <dt>
            <span id="internal">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.internal">Internal</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.internal ? 'true' : 'false'}</dd>
          <dt>
            <span id="shipmentItemId">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.shipmentItemId">Shipment Item Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.shipmentItemId}</dd>
          <dt>
            <span id="addedById">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.addedById">Added By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.addedById}</dd>
          <dt>
            <span id="modifiedById">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.modifiedById">Modified By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.modifiedById}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.addedByType}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.modifiedByType}</dd>
          <dt>
            <span id="margin">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.margin">Margin</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockEntity.margin}</dd>
          <dt>
            <span id="cessAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.cessAmount">Cess Amount</Translate>
            </span>
            <UncontrolledTooltip target="cessAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.help.cessAmount" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyStockEntity.cessAmount}</dd>
          <dt>
            <span id="exempted">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.exempted">Exempted</Translate>
            </span>
            <UncontrolledTooltip target="exempted">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.help.exempted" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyStockEntity.exempted ? 'true' : 'false'}</dd>
          <dt>
            <span id="importDuty">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.importDuty">Import Duty</Translate>
            </span>
            <UncontrolledTooltip target="importDuty">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.help.importDuty" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyStockEntity.importDuty}</dd>
          <dt>
            <span id="freeQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.freeQty">Free Qty</Translate>
            </span>
            <UncontrolledTooltip target="freeQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.help.freeQty" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyStockEntity.freeQty}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyStock.pharmacy">Pharmacy</Translate>
          </dt>
          <dd>{pharmacyStockEntity.pharmacy ? pharmacyStockEntity.pharmacy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyStock.drug">Drug</Translate>
          </dt>
          <dd>{pharmacyStockEntity.drug ? pharmacyStockEntity.drug.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyStock.supplier">Supplier</Translate>
          </dt>
          <dd>{pharmacyStockEntity.supplier ? pharmacyStockEntity.supplier.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyStock.stockBill">Stock Bill</Translate>
          </dt>
          <dd>{pharmacyStockEntity.stockBill ? pharmacyStockEntity.stockBill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyStock.uqcType">Uqc Type</Translate>
          </dt>
          <dd>{pharmacyStockEntity.uqcType ? pharmacyStockEntity.uqcType.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-stock" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-stock/${pharmacyStockEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyStockDetail;
